










import Vue from 'vue';
import { mapGetters } from 'vuex';

import Login from '@/web/components/signup/Login.vue';

export default Vue.extend({
  name: 'StudentLogin',
  components: {
    Login,
  },
  props: {
    onLoginFn: {
      type: Function,
      default: () => {
        return {};
      },
    },
  },
  computed: {
    ...mapGetters({
      showSignupLinkForStudio: 'studio/showSignupLinkForStudio',
    }),
  },
});
